import React from "react";
import search from "../assets/images/Group.png";


const SearchBar = ({ value, onChange, disabled }) => (
    <div className="search-wrap">
        <input
            type="text"
            value={value}
            onChange={onChange}
            placeholder="ابحث ..."
            className="search-input neon"
            dir="rtl"
            disabled={disabled}
        />
        <img src={search} className="search-icon" alt="" aria-hidden="true" />
    </div>
);


export default SearchBar;